<template>
  <div
    id="canvas-container-animation-spine-seasonpass-kingspass"
    ref="canvascontainer"
    :style="{ opacity: containerOpacity }"
    class="canvas-container-animation-spine-seasonpass-kingspass"
  ></div>
</template>

<script>
import AnimationSpineBaseFunctions from "@/components/animation/animation-spine-base-functions";
import sound_super_win from "@/assets/sound/animation/adelsliga-aufstieg-fanfare.mp3";

export default {
  name: "AnimationSeasonpassKingspass",
  mixins: [AnimationSpineBaseFunctions],
  props: {
    loop: {
      type: Boolean,
      default: true,
    },
    run: {
      type: Boolean,
      default: true,
    },
    tierLabel: {
      type: String,
      default: "",
    },
    badgeUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      containerId: "canvas-container-animation-spine-seasonpass-kingspass",
      json: "/assets/spines/events/winterbonusjagd/winterbonusjagd-getpass.json",
      atlas:
        "/assets/spines/events/winterbonusjagd/winterbonusjagd-getpass.atlas",
    };
  },

  watch: {
    run: function () {
      this.activateAnimation("main", false);
    },
    completed() {
      if (this.completed) {
        this.$emit("seasonpass-kingspass-ani-completed");
      }
    },
  },
  mounted() {
    this.setupAnimation("main", this.onSuccess);
  },

  methods: {
    onSuccess() {
      this.containerOpacity = 1;
      const text = document.createElement("div");
      text.innerHTML = this.$t("seasonpass.tier.activated", {
        0: this.tierLabel,
      });
      text.classList.add("text1", "to-center-abs");
      this.$refs.canvascontainer.appendChild(text);
      this.showText(text);

      if (this.badgeUrl) {
        this.$refs.canvascontainer.classList.add("has-dynamic-badge");

        const shield = document.createElement("img");
        shield.src = require("@/assets/img/animation/full-accomplishment/levelup-shield.png");
        shield.classList.add("dynamic-shield");
        this.$refs.canvascontainer.appendChild(shield);
        this.showText(shield);

        const badge = document.createElement("img");
        badge.src = this.badgeUrl;
        badge.classList.add("dynamic-badge");
        this.$refs.canvascontainer.appendChild(badge);
        this.showText(badge);
      }

      this.playSoundEffect(sound_super_win, false, 0.7);
      this.spinePlayer.animationState.addListener({
        complete: () => {
          this.$emit("seasonpass-kingspass-ani-completed");
        },
      });
    },
    showText(element) {
      const timeline = this.gsap.timeline();
      timeline
        .to(
          [element],
          0,
          {
            onComplete: () => {
              this.playSoundEffect(sound_super_win, false, 0.7);
            },
          },
          0
        )
        .fromTo(
          [element],
          0.8,
          {
            scale: 0,
          },
          {
            ease: "elastic",
            scale: 1,
          },
          1
        );
    },
  },
};
</script>

<style lang="scss">
.canvas-container-animation-spine-seasonpass-kingspass {
  pointer-events: none;
  width: 1121px;
  height: 715px;
  position: relative;

  canvas {
    position: absolute;
    z-index: 1000;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
    width: 100%;
    height: 100%;
  }

  /* Hide built-in winged crown from spine when dynamic badge in use */
  &.has-dynamic-badge canvas {
    opacity: 0 !important;
    visibility: hidden;
  }

  .text1 {
    font-family: Ubuntu-Medium;
    color: white;
    background: none;
    text-shadow: 1px 1px 2px #1ae5f4, 0 0 25px #1ae5f4, 0 0 5px #1ae5f4 !important;
    font-size: 44px;
    -webkit-text-fill-color: white;
    z-index: 1001;
    text-transform: uppercase;

    position: absolute;
    top: 75%;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    width: 90%;
    max-width: 1000px;
    text-align: center;
    line-height: 1.1;
    transform: scale(0);
    white-space: normal;
  }

  .dynamic-shield {
    position: absolute;
    top: 22%;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    width: 360px;
    height: auto;
    z-index: 1001;
    transform: scale(0);
    pointer-events: none;
  }

  .dynamic-badge {
    position: absolute;
    top: 28%;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    width: 180px;
    height: 180px;
    object-fit: contain;
    z-index: 1002;
    transform: scale(0);
    pointer-events: none;
  }
}
</style>
